var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitLands({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10685",
    "data-name": "Group 10685",
    transform: "translate(-720.892 -667.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10680",
    "data-name": "Group 10680",
    transform: "translate(720.892 667.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10235",
    "data-name": "Path 10235",
    d: "M-7590.194-21786.557h12.025a.764.764,0,0,1,.582.266l12.979,15.135a.766.766,0,0,1-.081,1.078l-15.595,13.5a.761.761,0,0,1-1.012-.008l-21.816-19.469a.77.77,0,0,1-.255-.607.774.774,0,0,1,.31-.582l12.407-9.16A.763.763,0,0,1-7590.194-21786.557Zm11.672,1.531h-11.42l-11.445,8.451,20.611,18.393,14.508-12.557Z",
    transform: "translate(7633.748 21846.393)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10236",
    "data-name": "Path 10236",
    d: "M-7597.668-21816.336a.765.765,0,0,1,.529.211l15.062,14.395a.767.767,0,0,1,.237.555v8.609a.764.764,0,0,1-.766.766h-11.818l-11.541,9.09a.764.764,0,0,1-.971-.02l-14.057-11.984a.759.759,0,0,1-.269-.574.772.772,0,0,1,.258-.582l22.828-20.273A.784.784,0,0,1-7597.668-21816.336Zm14.295,15.488-14.314-13.68-21.642,19.219,12.908,11,11.256-8.863a.769.769,0,0,1,.474-.164h11.317Z",
    transform: "translate(7621.263 21850.373)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_60",
    "data-name": "Subtraction 60",
    d: "M15.991,23.719a.751.751,0,0,1-.519-.2L.247,9.548A.771.771,0,0,1,.264,8.4L9.971,0a6.076,6.076,0,0,0,.347,1.728L1.916,9,16.087,22,30.24,13.644,18.218,2.9a5.681,5.681,0,0,0,.675-1.451L32.046,13.2a.768.768,0,0,1,.251.646.781.781,0,0,1-.371.588L16.378,23.61A.737.737,0,0,1,15.991,23.719Z",
    transform: "translate(36.482 6.027)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10238",
    "data-name": "Path 10238",
    d: "M-7555.586-21810.07a.778.778,0,0,1,.5.189l16.959,14.8a.768.768,0,0,1,.262.566.763.763,0,0,1-.244.572l-19.689,18.289a.761.761,0,0,1-.521.205.3.3,0,0,1-.042,0,.773.773,0,0,1-.538-.264l-13.076-15.137a.768.768,0,0,1-.187-.5v-8.771a.77.77,0,0,1,.382-.664l15.806-9.182A.779.779,0,0,1-7555.586-21810.07Zm15.814,15.586-15.9-13.881-14.949,8.686v8.043l12.37,14.322Z",
    transform: "translate(7638.86 21843.34)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10648",
    "data-name": "Group 10648",
    transform: "translate(32.941 21.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.721,
    cy: 20.721,
    rx: 20.721,
    ry: 20.721,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.721,
    cy: 20.721,
    rx: 20.221,
    ry: 20.221,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(79.082 42.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-2",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(46.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-2",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-2",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-2",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-2",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-2",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-2",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(47.87 68.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-3",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-3",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-3",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-3",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-3",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-3",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-4",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(12.976 44.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-4",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-4",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-4",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-4",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-4",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-4",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Users_-_Flaticon-3",
    "data-name": "Search results for Users - Flaticon-3",
    transform: "translate(761.692 692.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10242",
    "data-name": "Path 10242",
    d: "M25.13,14.96l-3.654-1.523V12.343a4.074,4.074,0,0,0,1.966-2.729h.082a1.229,1.229,0,0,0,.034-2.457l.4-.93a3.308,3.308,0,0,0-1.667-4.321l-1.143-.52a4.2,4.2,0,0,0-4.19.455l-.637.481a2.55,2.55,0,0,0-1.782,3.3,4.248,4.248,0,0,0-1.868.045,3.3,3.3,0,0,0-1.846-3.757l-1.143-.52a4.2,4.2,0,0,0-4.19.455l-.637.481A2.551,2.551,0,0,0,3.2,5.935l.612,1.222a1.229,1.229,0,1,0,.051,2.457h.082a4.08,4.08,0,0,0,1.966,2.728v1.094L2.26,14.96A2.042,2.042,0,0,0,1,16.85v5.46a.41.41,0,0,0,.41.41H4.276V26a.41.41,0,0,0,.41.41H22.7a.41.41,0,0,0,.41-.41V22.719h2.867a.41.41,0,0,0,.41-.41V16.85A2.042,2.042,0,0,0,25.13,14.96ZM15.076,6.636l1.143.521a2.489,2.489,0,0,1,1.254,3.251l-.123.281-.42-.848a.41.41,0,0,0-.614-.145l-.655.491a3.276,3.276,0,0,1-3.931,0L11.074,9.7a.405.405,0,0,0-.339-.071.41.41,0,0,0-.273.215l-.453.908-.338-.676a1.732,1.732,0,0,1,1.548-2.506,1.913,1.913,0,0,1,1.594.853l.129.193.681-.455-.129-.193a2.728,2.728,0,0,0-1.544-1.116A3.363,3.363,0,0,1,15.076,6.636Zm2.714,5.845h.41a.41.41,0,0,1,0,.819h-.41Zm-5.324,4.725a4.092,4.092,0,0,0,2.457,0v.838L13.7,19.274l-1.229-1.229Zm1.229-.63A3.28,3.28,0,0,1,10.419,13.3V11.759l.556-1.113.263.2a4.1,4.1,0,0,0,4.914,0l.263-.2.556,1.113V13.3A3.28,3.28,0,0,1,13.7,16.577ZM9.6,13.3H9.19a.41.41,0,0,1,0-.819H9.6ZM4.276,21.507V21.9H1.819V16.85a1.226,1.226,0,0,1,.756-1.133l3.906-1.627a.41.41,0,0,0,.252-.379V12.1a.428.428,0,0,0-.237-.371A3.263,3.263,0,0,1,4.706,9.16.41.41,0,0,0,4.3,8.8H3.867a.41.41,0,1,1,0-.819h.41a.41.41,0,0,0,.41-.412l0-.41a.41.41,0,0,0-.043-.18l-.7-1.406A1.731,1.731,0,0,1,5.119,3.1a.42.42,0,0,0,.16-.073l.7-.532a3.365,3.365,0,0,1,3.358-.364l1.144.52A2.489,2.489,0,0,1,11.74,5.9l-.066.154a3.967,3.967,0,0,0-.448.289l-.646.484h0a2.548,2.548,0,0,0-1.644,3.609l.613,1.224H9.19a1.229,1.229,0,1,0,0,2.457h.491a4.1,4.1,0,0,0,1.966,2.722V17.9L5.776,19.535A2.053,2.053,0,0,0,4.276,21.507Zm18.019,4.079H19.838V22.31h-.819v3.276H8.371V22.31H7.552v3.276H5.1V21.507A1.231,1.231,0,0,1,6,20.324l5.942-1.65,1.469,1.469a.41.41,0,0,0,.579,0l1.469-1.469,5.939,1.65a1.231,1.231,0,0,1,.9,1.184ZM25.571,21.9H23.114v-.393a2.053,2.053,0,0,0-1.5-1.973L15.743,17.9V16.842a4.105,4.105,0,0,0,1.966-2.722H18.2a1.229,1.229,0,0,0,0-2.457h-.376l.4-.93a3.308,3.308,0,0,0-1.667-4.321l-.95-.433-.2-.41A1.731,1.731,0,0,1,16.586,3.1a.42.42,0,0,0,.16-.073l.7-.532a3.365,3.365,0,0,1,3.358-.364l1.144.52A2.489,2.489,0,0,1,23.206,5.9l-.471,1.09a.41.41,0,0,0-.034.164l0,.41a.41.41,0,0,0,.41.41h.41a.41.41,0,0,1,0,.819h-.432a.41.41,0,0,0-.407.365,3.261,3.261,0,0,1-1.8,2.571.41.41,0,0,0-.227.367V13.71a.41.41,0,0,0,.252.378l3.908,1.629a1.226,1.226,0,0,1,.756,1.133Z",
    transform: "translate(-0.808 -0.834)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10242_-_Outline",
    "data-name": "Path 10242 - Outline",
    d: "M22.646,26.538H4.627a.6.6,0,0,1-.6-.6V22.853H1.351a.6.6,0,0,1-.6-.6v-5.46a2.227,2.227,0,0,1,1.378-2.067l3.536-1.474v-.857A4.273,4.273,0,0,1,3.736,9.747a1.428,1.428,0,0,1-1.374-1.39,1.422,1.422,0,0,1,1.1-1.414l-.491-.98A2.743,2.743,0,0,1,4.711,2.088l.607-.458A4.388,4.388,0,0,1,9.7,1.153l1.145.521a3.5,3.5,0,0,1,2.009,3.683,4.449,4.449,0,0,1,1.36-.035,2.743,2.743,0,0,1,1.963-3.233l.607-.458a4.388,4.388,0,0,1,4.383-.478l1.145.521a3.5,3.5,0,0,1,1.763,4.571l-.3.694a1.42,1.42,0,0,1-.239,2.809,4.266,4.266,0,0,1-1.928,2.647v.856l3.536,1.474a2.227,2.227,0,0,1,1.378,2.067v5.46a.6.6,0,0,1-.6.6H23.247v3.085A.6.6,0,0,1,22.646,26.538ZM3.806,9.365h.241l.031.154a3.889,3.889,0,0,0,1.873,2.6l.1.055v1.333L2.275,15.078a1.845,1.845,0,0,0-1.142,1.713v5.46a.218.218,0,0,0,.218.218H4.409v3.468a.218.218,0,0,0,.218.218H22.646a.218.218,0,0,0,.218-.218V22.469h3.058a.218.218,0,0,0,.218-.218v-5.46A1.845,1.845,0,0,0,25,15.078l-3.772-1.572V12.174l.1-.055a3.883,3.883,0,0,0,1.873-2.6l.031-.154h.256A1.037,1.037,0,0,0,23.5,7.291l-.287,0,.515-1.194a3.133,3.133,0,0,0-1.57-4.071L21.011,1.5a4.005,4.005,0,0,0-4,.435l-.666.5-.037.01A2.358,2.358,0,0,0,14.661,5.5l.109.316-.327-.065a4.074,4.074,0,0,0-1.784.043l-.305.077.072-.306a3.111,3.111,0,0,0-1.738-3.538L9.544,1.5a4.005,4.005,0,0,0-4,.435l-.666.5-.037.01A2.36,2.36,0,0,0,3.317,5.791l.747,1.493-.3.006A1.037,1.037,0,0,0,2.746,8.349,1.043,1.043,0,0,0,3.8,9.365ZM22.428,25.719h-2.84V22.443h-.436v3.276H8.121V22.443H7.685v3.276H4.845v-4.27a1.428,1.428,0,0,1,1.041-1.368l6.05-1.68,1.548,1.548a.218.218,0,0,0,.308,0L15.34,18.4l6.047,1.68a1.428,1.428,0,0,1,1.041,1.368Zm-2.457-.383h2.074V21.449a1.043,1.043,0,0,0-.761-1l-5.831-1.62-1.39,1.39a.6.6,0,0,1-.85,0l-1.39-1.39L5.989,20.45a1.043,1.043,0,0,0-.761,1v3.887H7.3V22.06H8.5v3.276H18.769V22.06h1.2Zm5.733-3.3h-2.84v-.585a1.869,1.869,0,0,0-1.36-1.788l-6.012-1.67V16.673l.1-.055a3.917,3.917,0,0,0,1.874-2.6l.032-.153h.647a1.037,1.037,0,1,0,0-2.074h-.667l.517-1.2a3.133,3.133,0,0,0-1.57-4.071l-1.012-.461-.235-.47a1.923,1.923,0,0,1,1.313-2.739.226.226,0,0,0,.086-.04l.7-.532A3.557,3.557,0,0,1,20.828,1.9l1.146.52a2.681,2.681,0,0,1,1.35,3.5l-.471,1.09a.216.216,0,0,0-.018.087l0,.409a.218.218,0,0,0,.218.219h.41a.6.6,0,1,1,0,1.2h-.432a.218.218,0,0,0-.217.194,3.437,3.437,0,0,1-1.908,2.722.216.216,0,0,0-.12.195v1.612a.217.217,0,0,0,.134.2l3.908,1.629a1.413,1.413,0,0,1,.874,1.31Zm-2.457-.383h2.074V16.791a1.032,1.032,0,0,0-.638-.956l-3.908-1.629a.6.6,0,0,1-.37-.555V12.04a.6.6,0,0,1,.334-.538,3.056,3.056,0,0,0,1.7-2.421.6.6,0,0,1,.6-.535h.432a.218.218,0,1,0,0-.436h-.41a.6.6,0,0,1-.6-.6l0-.408a.6.6,0,0,1,.049-.241l.471-1.09a2.31,2.31,0,0,0-1.157-3l-1.144-.52a3.174,3.174,0,0,0-3.165.344l-.7.531a.609.609,0,0,1-.234.108,1.54,1.54,0,0,0-1.052,2.193l.174.349.888.4a3.5,3.5,0,0,1,1.763,4.571l-.286.663h.085a1.42,1.42,0,1,1,0,2.84H17.8a4.3,4.3,0,0,1-1.927,2.639V17.7l5.731,1.592a2.253,2.253,0,0,1,1.64,2.157Zm-18.838.383H1.569V16.791a1.413,1.413,0,0,1,.874-1.31l3.906-1.627a.217.217,0,0,0,.134-.2V12.043a.236.236,0,0,0-.131-.2,3.44,3.44,0,0,1-1.9-2.717.218.218,0,0,0-.217-.194H3.808a.6.6,0,1,1,0-1.2h.41a.218.218,0,0,0,.218-.219l0-.41A.219.219,0,0,0,4.41,7L3.707,5.6A1.923,1.923,0,0,1,5.02,2.858a.226.226,0,0,0,.086-.04l.7-.532A3.557,3.557,0,0,1,9.361,1.9l1.146.52a2.681,2.681,0,0,1,1.35,3.5l-.092.214-.057.032a3.788,3.788,0,0,0-.426.275l-.676.506-.037.009a2.356,2.356,0,0,0-1.52,3.337L9.8,11.8H9.132a1.037,1.037,0,1,0,0,2.074h.647l.032.153a3.917,3.917,0,0,0,1.874,2.6l.1.055v1.318l-6.012,1.67a1.869,1.869,0,0,0-1.359,1.788ZM1.952,21.65H4.026v-.2a2.253,2.253,0,0,1,1.64-2.157L11.4,17.7v-.807A4.3,4.3,0,0,1,9.47,14.253H9.132a1.42,1.42,0,0,1,0-2.84H9.18l-.474-.946a2.739,2.739,0,0,1,1.73-3.87l.616-.461a4.178,4.178,0,0,1,.412-.271l.041-.094a2.31,2.31,0,0,0-1.157-3L9.2,2.249a3.174,3.174,0,0,0-3.165.344l-.7.531a.609.609,0,0,1-.234.108A1.54,1.54,0,0,0,4.05,5.425l.7,1.406a.6.6,0,0,1,.063.265l0,.409a.6.6,0,0,1-.6.605h-.41a.218.218,0,1,0,0,.436H4.24a.6.6,0,0,1,.6.535A3.059,3.059,0,0,0,6.523,11.5a.619.619,0,0,1,.343.538v1.617a.6.6,0,0,1-.37.556L2.59,15.835a1.032,1.032,0,0,0-.638.956Zm11.684-2.164-1.42-1.42V16.887l.249.078a3.9,3.9,0,0,0,2.342,0l.249-.078v1.179ZM12.6,17.907l1.037,1.037,1.037-1.037V17.4a4.3,4.3,0,0,1-2.074,0Zm1.037-1.2a3.477,3.477,0,0,1-3.468-3.468V11.655l.679-1.358.447.335a3.9,3.9,0,0,0,4.684,0l.447-.335.679,1.358v1.587A3.477,3.477,0,0,1,13.637,16.71Zm-3.085-4.964v1.5a3.085,3.085,0,1,0,6.169,0v-1.5l-.433-.867-.079.059a4.287,4.287,0,0,1-5.144,0l-.079-.059Zm7.589,1.688h-.6v-1.2h.6a.6.6,0,1,1,0,1.2Zm-.218-.383h.218a.218.218,0,1,0,0-.436h-.218Zm-8.19.383h-.6a.6.6,0,1,1,0-1.2h.6Zm-.6-.819a.218.218,0,1,0,0,.436H9.35v-.436Zm.819-1.495L9.441,10.1a1.923,1.923,0,0,1,1.719-2.784,2.1,2.1,0,0,1,1.754.938l.022.034.363-.242-.022-.034a2.537,2.537,0,0,0-1.436-1.037l-.424-.117.374-.231A3.555,3.555,0,0,1,15.1,6.4l1.145.522a2.681,2.681,0,0,1,1.35,3.5l-.288.658-.6-1.216a.217.217,0,0,0-.145-.115.221.221,0,0,0-.182.038l-.656.492a3.468,3.468,0,0,1-4.161,0L10.9,9.792a.218.218,0,0,0-.326.077Zm.82-1.755a.6.6,0,0,1,.36.121l.655.491a3.085,3.085,0,0,0,3.7,0l.655-.491a.609.609,0,0,1,.5-.105.6.6,0,0,1,.4.318l.236.476a2.311,2.311,0,0,0-1.2-2.9l-1.143-.521a3.172,3.172,0,0,0-2.575.007A2.92,2.92,0,0,1,13.6,7.8l.235.352-1,.667L12.6,8.468A1.718,1.718,0,0,0,11.163,7.7,1.54,1.54,0,0,0,9.784,9.929l.167.333.281-.565a.6.6,0,0,1,.539-.333Z",
    transform: "translate(-0.75 -0.775)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Equal_-_Flaticon-3",
    "data-name": "Search results for Equal - Flaticon-3",
    transform: "translate(768.14 720.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10576",
    "data-name": "Group 10576",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10575",
    "data-name": "Group 10575",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    "data-name": "Path 10130",
    d: "M.773,72.192h11.34a.773.773,0,0,0,0-1.547H.773a.773.773,0,0,0,0,1.547Z",
    transform: "translate(0 -67.037)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M.773,38.087h11.34a.773.773,0,1,0,0-1.546H.773a.773.773,0,0,0,0,1.546Z",
    transform: "translate(0 -36.541)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitLands);
export default __webpack_public_path__ + "static/media/splitLands.baeabaf33ac0b4ad9f49a7a8c16eff9b.svg";
export { ForwardRef as ReactComponent };